import React from "react";
import Localize from "components/service/localize";
import "./staff-summary-value.scss";

export const isStaffSummaryCount = value => Number.isSafeInteger(value) && value >= 0;

const StaffSummaryValue = ({ count, difference = null, compare = false, unavailable = false }) => {
    const known = !unavailable && isStaffSummaryCount(count);
    const comparable = known && compare && Number.isSafeInteger(difference);
    const state = comparable ? (difference === 0 ? " is-matched" : " is-mismatched") : "";
    return <span className={`sm-summary-value${state}`}>
        {known ? <>{count}{comparable && difference !== 0 &&
            <span className="sm-summary-difference"> ({difference > 0 ? "+" : "−"}{Math.abs(difference)})</span>}</> :
            <><span aria-hidden="true">—</span><span className="sm-summary-sr-only"><Localize>STAFF_MANAGEMENT.SummaryUnavailable</Localize></span></>}
    </span>;
};

export default StaffSummaryValue;
